export type ButtonType = 'button' | 'submit' | 'reset'

export type ButtonVariant = 'primary' | 'secondary' | 'tertiary'

export type ButtonIconPlacement = 'left' | 'right'
